<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ChTitle" id="ch1"><a id="page_xvi"></a><a id="page_1"></a><a href="#/Contents#rch1">What Makes the Dalai Lama Lovable?</a></h2>
<p class="noindentp"><span><span>His posture</span></span></p>
<p class="noindentp"><span><span>From so many years</span></span></p>
<p class="noindentp"><span><span>Holding his robe with one hand</span></span></p>
<p class="noindentp"><span><span>Is odd.</span></span></p>
<p class="noindentp1"><span><span>His gait</span></span></p>
<p class="noindentp"><span><span>Also.</span></span></p>
<p class="noindentp1"><span><span>One’s own body</span></span></p>
<p class="noindentp"><span><span>Aches</span></span></p>
<p class="noindentp"><span><span>Witnessing</span></span></p>
<p class="noindentp"><span><span>The sloping</span></span></p>
<p class="noindentp"><span><span>Shoulders</span></span></p>
<p class="noindentp"><span><span>&amp; Angled</span></span></p>
<p class="noindentp"><span><span>Neck;</span></span></p>
<p class="noindentp1"><span><span>One hopes</span></span></p>
<p class="noindentp"><span><span>He</span></span></p>
<p class="noindentp"><span><span>Attends</span></span></p>
<p class="noindentp"><span><span>Yoga class</span></span></p>
<p class="noindentp"><span><span>Or does Yoga</span></span></p>
<p class="noindentp"><span><span>On his own</span></span></p>
<p class="noindentp"><span><span><a id="page_2"></a>As part</span></span></p>
<p class="noindentp"><span><span>Of prayer.</span></span></p>
<p class="noindentp1"><span><span>He smiles</span></span></p>
<p class="noindentp"><span><span>As he bows</span></span></p>
<p class="noindentp"><span><span>To Everything:</span></span></p>
<p class="noindentp"><span><span>Accepting</span></span></p>
<p class="noindentp"><span><span>The heavy</span></span></p>
<p class="noindentp"><span><span>Burdens</span></span></p>
<p class="noindentp"><span><span>Of</span></span></p>
<p class="noindentp"><span><span>This earth;</span></span></p>
<p class="noindentp1"><span><span>Its</span></span></p>
<p class="noindentp"><span><span>Toxic</span></span></p>
<p class="noindentp"><span><span>Evils</span></span></p>
<p class="noindentp"><span><span>&amp; Prolific</span></span></p>
<p class="noindentp"><span><span>Insults.</span></span></p>
<p class="noindentp1"><span><span>Even so,</span></span></p>
<p class="noindentp"><span><span>He sleeps</span></span></p>
<p class="noindentp"><span><span>Through</span></span></p>
<p class="noindentp"><span><span>The night</span></span></p>
<p class="noindentp"><span><span>Like a child</span></span></p>
<p class="noindentp"><span><span>Because</span></span></p>
<p class="noindentp"><span><span>Thank goodness</span></span></p>
<p class="noindentp"><span><span>That is something</span></span></p>
<p class="noindentp"><span><span><a id="page_3"></a>Else</span></span></p>
<p class="noindentp"><span><span>Daylong</span></span></p>
<p class="noindentp"><span><span>Meditation</span></span></p>
<p class="noindentp"><span><span>Assures.</span></span></p>
<p class="noindentp1"><span><span>You could cry</span></span></p>
<p class="noindentp"><span><span>Yourself to sleep</span></span></p>
<p class="noindentp"><span><span>On his behalf</span></span></p>
<p class="noindentp"><span><span>&amp; He</span></span></p>
<p class="noindentp"><span><span>Has done that</span></span></p>
<p class="noindentp"><span><span>Too.</span></span></p>
<p class="noindentp1"><span><span>Life</span></span></p>
<p class="noindentp"><span><span>Has been</span></span></p>
<p class="noindentp"><span><span>A great</span></span></p>
<p class="noindentp"><span><span>Endless</span></span></p>
<p class="noindentp"><span><span>Tearing away</span></span></p>
<p class="noindentp"><span><span>For</span></span></p>
<p class="noindentp"><span><span>Him.</span></span></p>
<p class="noindentp1"><span><span>From</span></span></p>
<p class="noindentp"><span><span>Mother, Father, Siblings, Country, Home.</span></span></p>
<p class="noindentp"><span><span>And yet</span></span></p>
<p class="noindentp"><span><span>Clearly</span></span></p>
<p class="noindentp"><span><span>His mother</span></span></p>
<p class="noindentp"><span><span>Loved him;</span></span></p>
<p class="noindentp1"><span><span><a id="page_4"></a>His brother &amp; sister</span></span></p>
<p class="noindentp"><span><span>Too: Even his</span></span></p>
<p class="noindentp"><span><span>Not so constant father,</span></span></p>
<p class="noindentp"><span><span>Who</span></span></p>
<p class="noindentp"><span><span>When Tenzin was</span></span></p>
<p class="noindentp"><span><span>A boy</span></span></p>
<p class="noindentp"><span><span>Shared</span></span></p>
<p class="noindentp"><span><span>With him</span></span></p>
<p class="noindentp"><span><span>Delicious</span></span></p>
<p class="noindentp"><span><span>Scraps</span></span></p>
<p class="noindentp"><span><span>Of</span></span></p>
<p class="noindentp"><span><span>Succulent</span></span></p>
<p class="noindentp"><span><span>Pork.</span></span></p>
<p class="noindentp1"><span><span>He laughs</span></span></p>
<p class="noindentp"><span><span>Telling this</span></span></p>
<p class="noindentp"><span><span>Story</span></span></p>
<p class="noindentp"><span><span>Over half a century</span></span></p>
<p class="noindentp"><span><span>Later</span></span></p>
<p class="noindentp"><span><span>&amp;</span></span></p>
<p class="noindentp"><span><span>To who knows</span></span></p>
<p class="noindentp"><span><span>How many</span></span></p>
<p class="noindentp"><span><span>Puzzled</span></span></p>
<p class="noindentp"><span><span>Vegetarians:</span></span></p>
<p class="noindentp"><span><span>About</span></span></p>
<p class="noindentp"><span><span>The way he sat</span></span></p>
<p class="noindentp1"><span><span><a id="page_5"></a>Behind</span></span></p>
<p class="noindentp"><span><span>His father’s chair</span></span></p>
<p class="noindentp"><span><span>Like a dog,</span></span></p>
<p class="noindentp"><span><span>Relishing</span></span></p>
<p class="noindentp"><span><span>Each juicy</span></span></p>
<p class="noindentp"><span><span>Greasy</span></span></p>
<p class="noindentp"><span><span>Bite.</span></span></p>
<p class="noindentp"><span><span>Whenever I see</span></span></p>
<p class="noindentp"><span><span>The Dalai Lama</span></span></p>
<p class="noindentp"><span><span>My first impulse</span></span></p>
<p class="noindentp"><span><span>Is to laugh</span></span></p>
<p class="noindentp"><span><span>I am so happy</span></span></p>
<p class="noindentp"><span><span>To</span></span></p>
<p class="noindentp"><span><span>Lay eyes</span></span></p>
<p class="noindentp"><span><span>On</span></span></p>
<p class="noindentp"><span><span>One</span></span></p>
<p class="noindentp"><span><span>So effortlessly</span></span></p>
<p class="noindentp"><span><span>Beautiful.</span></span></p>
<p class="noindentp1"><span><span>That balding head</span></span></p>
<p class="noindentp"><span><span>That holds</span></span></p>
<p class="noindentp"><span><span>A shine;</span></span></p>
<p class="noindentp"><span><span>Those wire framed</span></span></p>
<p class="noindentp"><span><span>Glasses</span></span></p>
<p class="noindentp"><span><span>That might</span></span></p>
<p class="noindentp"><span><span>Have come</span></span></p>
<p class="noindentp"><span><span><a id="page_6"></a>From</span></span></p>
<p class="noindentp"><span><span>Anywhere.</span></span></p>
<p class="noindentp1"><span><span>That look of having offered</span></span></p>
<p class="noindentp"><span><span><i>All he has.</i></span></span></p>
<p class="noindentp"><span><span>He is my teacher;</span></span></p>
<p class="noindentp"><span><span>Just staying alive.</span></span></p>
<p class="noindentp"><span><span>Other teachers</span></span></p>
<p class="noindentp"><span><span>I have had</span></span></p>
<p class="noindentp"><span><span>Resemble him</span></span></p>
<p class="noindentp"><span><span>In some way;</span></span></p>
<p class="noindentp1"><span><span>They too</span></span></p>
<p class="noindentp"><span><span>Were</span></span></p>
<p class="noindentp"><span><span>&amp;</span></span></p>
<p class="noindentp"><span><span>Are</span></span></p>
<p class="noindentp"><span><span>Smart</span></span></p>
<p class="noindentp"><span><span>And Humble;</span></span></p>
<p class="noindentp"><span><span>Fascinated</span></span></p>
<p class="noindentp"><span><span>By Science &amp; things like</span></span></p>
<p class="noindentp"><span><span>Time,</span></span></p>
<p class="noindentp"><span><span>Eternity,</span></span></p>
<p class="noindentp"><span><span>Cause &amp; Effect;</span></span></p>
<p class="noindentp"><span><span>The Evolution</span></span></p>
<p class="noindentp"><span><span>Of the Soul.</span></span></p>
<p class="noindentp1"><span><span><a id="page_7"></a>A</span></span></p>
<p class="noindentp"><span><span>Soul</span></span></p>
<p class="noindentp"><span><span>That</span></span></p>
<p class="noindentp"><span><span>Might</span></span></p>
<p class="noindentp"><span><span>Or might not</span></span></p>
<p class="noindentp"><span><span>Exist.</span></span></p>
<p class="noindentp1"><span><span>They too</span></span></p>
<p class="noindentp"><span><span>See all of us</span></span></p>
<p class="noindentp"><span><span>—Banker, murderer, gardener, thief—</span></span></p>
<p class="noindentp"><span><span>When they look</span></span></p>
<p class="noindentp"><span><span>Out across</span></span></p>
<p class="noindentp"><span><span>The world:</span></span></p>
<p class="noindentp1"><span><span>But that is not all</span></span></p>
<p class="noindentp"><span><span>They see.</span></span></p>
<p class="noindentp1"><span><span>They see our suffering;</span></span></p>
<p class="noindentp"><span><span>Our striving</span></span></p>
<p class="noindentp"><span><span>To find</span></span></p>
<p class="noindentp"><span><span>The right path;</span></span></p>
<p class="noindentp"><span><span>The one with heart</span></span></p>
<p class="noindentp"><span><span>We may only</span></span></p>
<p class="noindentp"><span><span>Have heard about.</span></span></p>
<p class="noindentp1"><span><span>The Dalai Lama is Cool</span></span></p>
<p class="noindentp"><span><span><a id="page_8"></a>A modern word</span></span></p>
<p class="noindentp"><span><span>For</span></span></p>
<p class="noindentp"><span><span>“Divine”</span></span></p>
<p class="noindentp"><span><span>Because he wants</span></span></p>
<p class="noindentp"><span><span>Only</span></span></p>
<p class="noindentp"><span><span>Our collective</span></span></p>
<p class="noindentp"><span><span>Health</span></span></p>
<p class="noindentp"><span><span>&amp; Happiness.</span></span></p>
<p class="noindentp1"><span><span><i>That</i>’<i>s it</i>!</span></span></p>
<p class="noindentp1"><span><span>What makes</span></span></p>
<p class="noindentp"><span><span>Him</span></span></p>
<p class="noindentp"><span><span>Lovable</span></span></p>
<p class="noindentp"><span><span>Is</span></span></p>
<p class="noindentp"><span><span>His holiness.</span></span></p>
<p class="centers"><span><span>*<span class="spaces"></span>*<span class="spaces"></span>*</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter001.vue?4f146380